var util = {
  calc_digitos_posicoes(digitos, posicoes = 10, soma_digitos = 0) {
    digitos = digitos.toString();
    for (var i = 0; i < digitos.length; i++) {
      soma_digitos = soma_digitos + digitos[i] * posicoes;
      posicoes--;
      if (posicoes < 2) {
        posicoes = 9;
      }
    }
    soma_digitos = soma_digitos % 11;
    if (soma_digitos < 2) {
      soma_digitos = 0;
    } else {
      soma_digitos = 11 - soma_digitos;
    }

    var cpf = digitos + soma_digitos;

    return cpf;
  },
  valida_cpf(valor) {
    valor = valor.toString();
    valor = valor.replace(/[^0-9]/g, "");
    var digitos = valor.substr(0, 9);
    var novo_cpf0 = this.calc_digitos_posicoes(digitos);
    var novo_cpf = this.calc_digitos_posicoes(novo_cpf0, 11);
    if (
      novo_cpf === valor &&
      novo_cpf !== "00000000000" &&
      novo_cpf !== "11111111111" &&
      novo_cpf !== "22222222222" &&
      novo_cpf !== "33333333333" &&
      novo_cpf !== "44444444444" &&
      novo_cpf !== "55555555555" &&
      novo_cpf !== "66666666666" &&
      novo_cpf !== "77777777777" &&
      novo_cpf !== "88888888888" &&
      novo_cpf !== "99999999999"
    ) {
      return true;
    } else {
      return false;
    }
  },
  valida_cnpj(valor) {
    if (!valor) {
      return false;
    }

    const valorBase = "0".charCodeAt(0);
    const pesosDV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const cnpjSemMascara = valor.toString().trim().toUpperCase().replace(/[./-]/g, "");

    if (!/^([A-Z\d]){12}(\d){2}$/.test(cnpjSemMascara)) {
      return false;
    }

    if (cnpjSemMascara === "00000000000000") {
      return false;
    }

    let somatorioDV1 = 0;
    let somatorioDV2 = 0;
    const baseCnpj = cnpjSemMascara.substring(0, 12);

    for (let i = 0; i < 12; i++) {
      const valorCaractere = baseCnpj.charCodeAt(i) - valorBase;
      somatorioDV1 += valorCaractere * pesosDV[i + 1];
      somatorioDV2 += valorCaractere * pesosDV[i];
    }

    const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
    somatorioDV2 += dv1 * pesosDV[12];
    const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);

    return cnpjSemMascara.substring(12) === `${dv1}${dv2}`;
  },
  valida_nif(nif) {
    if (!["1", "2", "3", "5", "6", "8"].includes(nif.substr(0, 1)) && !["45", "70", "71", "72", "77", "79", "90", "91", "98", "99"].includes(nif.substr(0, 2))) return false;

    let total = nif[0] * 9 + nif[1] * 8 + nif[2] * 7 + nif[3] * 6 + nif[4] * 5 + nif[5] * 4 + nif[6] * 3 + nif[7] * 2;

    let modulo11 = total - parseInt(total / 11) * 11;
    let comparador = modulo11 == 1 || modulo11 == 0 ? 0 : 11 - modulo11;

    return nif[8] == comparador;
  },
  valida_rut_uruguaio(rut) {
    //* Validação do RUT Uruguaio (Registro Único Tributario)
    //* O RUT tem 12 dígitos, sendo o último o dígito verificador
    //* Algoritmo: módulo 11 com pesos 4,3,2,9,8,7,6,5,4,3,2 da esquerda para a direita
    if (!rut) return false;

    //* Remove caracteres não numéricos (pontos, hífens, etc.)
    const rutLimpo = rut.replace(/\D/g, "");

    //* RUT deve ter 12 dígitos
    if (rutLimpo.length !== 12) return false;

    //* Pesos para o cálculo do dígito verificador
    const pesos = [4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    //* Calcula a soma ponderada dos primeiros 11 dígitos
    let soma = 0;
    for (let i = 0; i < 11; i++) {
      soma += parseInt(rutLimpo.charAt(i)) * pesos[i];
    }

    //* Calcula o dígito verificador
    const resto = soma % 11;
    let digitoCalculado = 11 - resto;
    if (digitoCalculado === 11) digitoCalculado = 0;
    if (digitoCalculado === 10) digitoCalculado = 0; //* Alguns sistemas usam 0 quando dá 10

    //* Compara com o dígito verificador informado (último dígito)
    const digitoInformado = parseInt(rutLimpo.charAt(11));

    return digitoCalculado === digitoInformado;
  },
  valida_email(email) {
    const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    // obsoleto: /^[a-zA-Z0-9][a-zA-Z0-9._-]+@([a-zA-Z0-9._-]+\.)[a-zA-Z-0-9]{2,3}$/
    return emailRegexp.test(email);
  },
  valida_url(url) {
    const urlRegexp =
      /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    return url == "http://localhost" || urlRegexp.test(url);
  },
  valida_competencia_futura(compet) {
    var retorno = true;
    if (compet != null && compet != "") {
      var dataAtualAux = new Date();
      var dataAtual = new Date(dataAtualAux.getFullYear(), dataAtualAux.getMonth(), 1);
      var dataLimite = new Date(new Date(dataAtualAux.getFullYear() + 20, dataAtualAux.getMonth(), 1)); //limite para datas: 20 anos
      var x = compet.split("/");
      var confere = new Date(x[1], x[0] - 1, "01");
      var confere2 =
        (confere.getDate() < 10 ? "0" : "") + confere.getDate() + "/" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "/" + confere.getFullYear();
      compet = "01/" + compet;
      if (!confere || compet != confere2 || confere < dataAtual || confere > dataLimite) {
        retorno = false;
      }
    }
    return retorno;
  },

  limparObjeto(objeto, valor) {
    Object.keys(objeto).map((campo) => {
      objeto[campo] = valor;
    });
  },

  validaErros(objeto, erros) {
    //faz um map nas mensagens de retorno
    erros.map((erro) => {
      //faz um map no objeto de validação
      Object.keys(objeto).map((campo) => {
        //se encontrar o campo na mensagem ele seta a mensagem de erro
        if (erro.campo == campo) {
          if (Array.isArray(erro.mensagem)) {
            objeto[campo] = "";
            erro.mensagem.map((element) => {
              //se encontrar o campo na mensagem ele seta a mensagem de erro
              objeto[campo] += (objeto[campo] == "" ? "" : " | ") + element.mensagem;
            });
          }
          if (!objeto[campo]) {
            objeto[campo] = erro.mensagem;
          }
        }
      });
    });
  },

  isDDDvalido(ddd) {
    var retorno = ddd.match("((([1,4,6,8,9][1-9])|(2[1,2,4,7,8])|(3[1-5])|(3[7-8])|(5[1,3,4,5])|(7[1,3,4,5,7,9])))");
    return retorno != null;
  },

  valida_data(date) {
    var retorno = true;
    if (date != null && date != "") {
      date = date.substr(0, 10); //* remove a parte do horário
      var dataAtualAux = new Date();
      var dataLimiteInicio = new Date(new Date(2007, 0, 1));
      var dataLimiteFim = new Date(new Date(dataAtualAux.getFullYear() + 20, dataAtualAux.getMonth(), 1));

      var x = date.split("-");
      var confere = new Date(x[0], x[1] - 1, x[2]);
      var confere2 =
        confere.getFullYear() + "-" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "-" + (confere.getDate() < 10 ? "0" : "") + confere.getDate();
      if (!confere || date != confere2 || confere < dataLimiteInicio || confere > dataLimiteFim) {
        retorno = false;
      }
    } else {
      retorno = false;
    }
    return retorno;
  },

  valida_data_BR(date) {
    var retorno = true;
    if (date) {
      date = date.substr(0, 10); //* remove a parte do horário
      //limite para datas: 01/01/2007 a hoje+20 anos
      var dataAtualAux = new Date();
      var dataLimiteInicio = new Date(new Date(2007, 0, 1));
      var dataLimiteFim = new Date(new Date(dataAtualAux.getFullYear() + 20, dataAtualAux.getMonth(), 1));

      var x = date.split("/");
      var confere = new Date(x[2], x[1] - 1, x[0]);
      var confere2 =
        (confere.getDate() < 10 ? "0" : "") + confere.getDate() + "/" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "/" + confere.getFullYear();
      if (!confere || date != confere2 || confere < dataLimiteInicio || confere > dataLimiteFim) {
        retorno = false;
      }
    } else {
      retorno = false;
    }
    return retorno;
  },

  valida_data_nasc_BR(date) {
    var retorno = true;
    if (date) {
      date = date.substr(0, 10); //* remove a parte do horário
      var dataLimite = new Date(new Date(1900, 0, 1)); //limite para datas de nascimento: 01/01/1900

      var x = date.split("/");
      var confere = new Date(x[2], x[1] - 1, x[0]);
      var confere2 =
        (confere.getDate() < 10 ? "0" : "") + confere.getDate() + "/" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "/" + confere.getFullYear();
      if (!confere || date != confere2 || confere < dataLimite || confere > new Date()) {
        retorno = false;
      }
    }
    return retorno;
  },

  valida_data_futura(date, hoje) {
    var retorno = true;
    if (date != null && date != "") {
      date = date.substr(0, 10); //* remove a parte do horário
      var dataAtual = new Date();
      if (hoje) {
        //* Considera o dia atual
        dataAtual.setDate(dataAtual.getDate() - 1);
      }
      var dataLimite = new Date(new Date(2007, 0, 1)); //limite para datas: 01/01/2007

      var x = date.split("-");
      var confere = new Date(x[0], x[1] - 1, x[2]);
      var confere2 =
        confere.getFullYear() + "-" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "-" + (confere.getDate() < 10 ? "0" : "") + confere.getDate();
      if (!confere || date != confere2 || confere < dataLimite || confere < dataAtual) {
        retorno = false;
      }
    }
    return retorno;
  },

  valida_data_futura_BR(date, hoje) {
    var retorno = true;
    if (date != null && date != "") {
      date = date.substr(0, 10); //* remove a parte do horário
      var dataAtual = new Date();
      if (hoje) {
        //* Considera o dia atual
        dataAtual.setDate(dataAtual.getDate() - 1);
      }
      var dataLimite = new Date(new Date(2007, 0, 1)); //limite para datas: 01/01/2007

      var x = date.split("/");
      var confere = new Date(x[2], x[1] - 1, x[0]);
      var confere2 =
        (confere.getDate() < 10 ? "0" : "") + confere.getDate() + "/" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "/" + confere.getFullYear();
      if (!confere || date != confere2 || confere < dataLimite || confere < dataAtual) {
        retorno = false;
      }
    }
    return retorno;
  },

  valida_data_passada_BR(date, hoje, limitar) {
    var retorno = true;
    if (date != null && date != "") {
      date = date.substr(0, 10); //* remove a parte do horário
      var dataAtual = new Date();
      if (!hoje) {
        //* Não considera o dia atual
        dataAtual.setDate(dataAtual.getDate() - 1);
      }
      var dataLimite = null;
      if (limitar) {
        dataLimite = new Date(new Date(2007, 0, 1)); //limite para datas de quitação: 01/01/2007
      } else {
        dataLimite = new Date(new Date(1900, 0, 1)); //limite para datas de criação: 01/01/1900 (pois DP tem base antiga)
      }

      var x = date.split("/");
      var confere = new Date(x[2], x[1] - 1, x[0]);
      var confere2 =
        (confere.getDate() < 10 ? "0" : "") + confere.getDate() + "/" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "/" + confere.getFullYear();
      if (!confere || date != confere2 || confere < dataLimite || confere > dataAtual) {
        retorno = false;
      }
    }
    return retorno;
  },

  valida_hora(hora) {
    if (hora && hora.length == 5 && parseInt(hora.substring(0, 2)) <= 23 && parseInt(hora.substring(3, 5)) <= 59) {
      return true;
    } else {
      return false;
    }
  },

  valida_nome(text) {
    if (text == "") {
      //* Não obriga o preenchimento, apenas verifica se não possui caracteres estranhos
      return true;
    }
    const textRegexp = /^[A-Za-záàâãéèêíïóôõöúüçñÁÀÂÃÉÈÍÏÓÔÕÖÚÜÇÑ'ºª&/.\- \d]+$/;
    return textRegexp.test(text);
  },

  valida_senha(text) {
    var retorno = true;
    var letras = [];
    for (let index = 0; index < text.length; index++) {
      const letra = text.substr(index, 1);
      var achou = false;
      letras.forEach((element) => {
        if (element.letra == letra) {
          element.qtde++;
          achou = true;
          if (element.qtde > 5) {
            retorno = "Senha não pode ter o mesmo caractere (" + letra + ") mais de 5 vezes";
          }
        }
      });
      if (!achou) {
        letras.push({ letra: letra, qtde: 1 });
      }
    }
    return retorno;
  },

  pLetra(text) {
    if (!text || text === "" || text.trim() === "") {
      return "";
    }

    //* Remove excesso de espaços em branco
    text = text.trim();
    text = text.replace(/[–]/g, "-");
    text = text.replace(/\s\s+/g, " ");
    text = text.replace(/[ ]/g, " ");
    text = text.replace(/[Ɵ]/g, "");

    if (text !== text.toLowerCase() && text !== text.toUpperCase()) {
      //* Só irá converter se todos os caracteres estiverem em minúsculos ou maiúsculos (para permitir manter uma correção, ex: APM - Associação de Pais e Mestres)
      return text;
    }
    if (text === text.toUpperCase()) {
      //* Para padronização do sistema, não permite nomes totalmente em maiúsculas
      text = text.toLowerCase();
    }
    var words = text.split(" ");
    for (var a = 0; a < words.length; a++) {
      //* Converte primeira letra de cada palavra em maiúsculo, ignorando os artigos e conjunções abaixo
      var w = words[a];
      words[a] = w[0].toUpperCase() + w.slice(1).toLowerCase();
      if (w === "da" || w === "de" || w === "do" || w === "das" || w === "dos" || w === "a" || w === "e" || w === "o" || w === "com" || w === "na" || w === "em" || w === "no") {
        words[a] = w;
      }
      if (w === w.toUpperCase()) {
        //* Mantém siglas em maiúsculas
        words[a] = w;
      }
    }
    return words.join(" ");
  },
  formatDDMM(date) {
    try {
      if (date && date instanceof Date) {
        date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      }
      if (!date) return null;
      if (date.indexOf("T")) {
        date = date.split("T")[0];
      }
      if (date.indexOf(" ")) {
        date = date.split(" ")[0];
      }
      const partes = date.split("-");
      return `${partes[2].padStart(2, "0")}/${partes[1].padStart(2, "0")}`;
    } catch {
      return null;
    }
  },
  formatMMAAAA(anomes) {
    try {
      if (!anomes) return null;
      const partes = anomes.split("-");
      return `${partes[1].padStart(2, "0")}/${partes[0].padStart(4, "0")}`;
    } catch {
      return null;
    }
  },
  formatDate(date) {
    try {
      if (date && date instanceof Date) {
        date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      }
      if (!date) return null;
      if (date.indexOf("T")) {
        date = date.split("T")[0];
      }
      if (date.indexOf(" ")) {
        date = date.split(" ")[0];
      }
      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    } catch {
      return null;
    }
  },
  formatDateUS(date) {
    if (!date) return null;
    const [day, month, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  },
  parseDate(date) {
    if (!date || date.length < 10) return null;
    date = date.substr(0, 10); //* remove a parte do horário
    const [day, month, year] = date.split("/");
    return new Date(year, month - 1, day);
  },
  parseDateTime(datetime) {
    if (!datetime) return null;
    var date = datetime.split(" ")[0];
    var time = datetime.split(" ")[1];
    const [day, month, year] = date.split("/");
    const [hour, minute, second] = time.split(":");
    return new Date(year, month - 1, day, hour, minute, second);
  },

  parseDateUS(date) {
    if (!date) return null;
    if (date instanceof Date) {
      date = date.getFullYear() + "-" + (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1) + "-" + (date.getDate() < 10 ? "0" : "") + date.getDate();
    }
    date = date.substr(0, 10); //* remove a parte do horário
    const [year, month, day] = date.split("-");
    return new Date(year, month - 1, day, 0, 0, 0, 0);
  },

  formatDateTime(datetime) {
    if (!datetime) return null;
    if (datetime && datetime != null && datetime != "") {
      var options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      };
      datetime = new Date(datetime);
      var portugueseTime = new Intl.DateTimeFormat(["pt-BR", "pt-PT"], options);
      return portugueseTime.format(datetime);
    } else {
      return null;
    }
  },
  formatDateUTC(datetime) {
    if (!datetime) return null;
    if (datetime && datetime != null && datetime != "") {
      var options = {
        year: "numeric",
        month: "numeric",
        day: "numeric"
      };
      datetime = new Date(datetime);
      var portugueseTime = new Intl.DateTimeFormat(["pt-BR", "pt-PT"], options);
      return portugueseTime.format(datetime);
    } else {
      return null;
    }
  },
  formatDateTimeUTC(datetime) {
    if (!datetime) return null;
    if (datetime && datetime != null && datetime != "") {
      var options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      };
      datetime = new Date(datetime);
      var portugueseTime = new Intl.DateTimeFormat(["pt-BR", "pt-PT"], options);
      return portugueseTime.format(datetime);
    } else {
      return null;
    }
  },
  formatDateUSTime(datetime) {
    if (!datetime) return null;
    var date = datetime.split(" ")[0];
    var time = datetime.split(" ")[1];
    const [day, month, year] = date.split("/");
    var [hour, minute, second] = time.split(":");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")} ${hour}:${minute}:${second}`;
  },
  dateToStringUS(date) {
    if (date instanceof Date) {
      date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    }
    if (!date) return null;
    if (date.indexOf("T")) {
      date = date.split("T")[0];
    }
    if (date.indexOf(" ")) {
      date = date.split(" ")[0];
    }
    const [year, month, day] = date.split("-");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  },

  formatNumber(valor, pais) {
    if (!valor) {
      valor = 0;
    }
    const formatter = new Intl.NumberFormat("pt-BR", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    var retorno = formatter.format(valor);
    if (pais && pais == "PT") {
      retorno = retorno.replace(/[.]/g, " ");
    }
    return retorno;
  },
  formatCurrency(valor, pais, mostrarSimbolo) {
    if (!valor) {
      valor = 0;
    }
    const formatter = new Intl.NumberFormat("pt-BR", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    var retorno = formatter.format(valor);
    if (pais && pais == "PT") {
      retorno = retorno.replace(/[.]/g, " ");
    }
    if (mostrarSimbolo) {
      if (pais == "PT") {
        retorno = retorno + " €";
      } else {
        retorno = "R$ " + retorno;
      }
    }
    return retorno;
  },
  formatCurrency4(valor) {
    if (!valor) return "0,0000";
    const formatter = new Intl.NumberFormat("pt-BR", {
      style: "decimal",
      minimumFractionDigits: 4,
      maximumFractionDigits: 4
    });
    return formatter.format(valor);
  },
  escondeCartao(numero) {
    var retorno = numero;
    if (numero && numero.length > 4) {
      retorno = "***" + numero.substring(numero.length - 4);
    }
    return retorno;
  },
  isFormaPgto1Parcela(tipoFormaPgto) {
    //* Só permite vender em 1x
    var retorno = false;
    var formasPgto = [
      "A_VISTA",
      // "APPLE", não desenvolvido
      "BONIFICACAO",
      "COMPENSACAO",
      "CORTESIA",
      // "CREDITO",descontinuado
      "PACOTE"
    ];
    //permitir lançar uma permuta a receber ou a pagar parcelada (agenda para permutar $x,xx por mês)
    // "PERMUTA_PAGAR",
    // "PERMUTA_RECEBER"
    if (formasPgto.includes(tipoFormaPgto)) {
      retorno = true;
    }
    return retorno;
  },
  isFormaPgtoEspeciais(tipoFormaPgto) {
    //* Não permite alterar de/para outra forma
    var retorno = false;
    var formasPgto = [
      // "APPLE", não desenvolvido
      "BONIFICACAO",
      "COMPENSACAO",
      "CORTESIA",
      // "CREDITO", descontinuado
      "PACOTE",
      "PERMUTA_PAGAR",
      "PERMUTA_RECEBER"
    ];
    if (formasPgto.includes(tipoFormaPgto)) {
      retorno = true;
    }
    return retorno;
  },
  isFormaPgtoValorZero(tipoFormaPgto) {
    var retorno = false;
    var formasPgto = ["BONIFICACAO", "COMPENSACAO", "CORTESIA"];
    if (formasPgto.includes(tipoFormaPgto)) {
      retorno = true;
    }
    return retorno;
  },
  imprimir(corpo) {
    const WinPrint = window.open("", "", "left=0,top=0,width=1200,height=900,toolbar=0,scrollbars=0,status=0");

    WinPrint.document.write(corpo);
    WinPrint.document.close();
    WinPrint.onload = function () {
      //* Dá uma pausa para esperar carregar a imagem e a fonte (se houver)
      WinPrint.focus();
    };
  },
  nullToString(valor) {
    return valor == null || valor == "undefined" ? "" : valor.toString();
  },
  removeAcentos(texto) {
    if (texto) {
      texto = texto.replace(/\s\s+/g, " ");
      texto = texto.replace(/[°]/g, "o");
      texto = texto.replace(/[º]/g, "o");
      texto = texto.replace(/[ª]/g, "a");
      texto = texto.replace(/[ ]/g, " ");
      texto = texto.replace(/[Ɵ]/g, "");
      texto = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      texto = texto.trim();
    }
    return texto;
  },
  removeEspeciais(texto) {
    if (texto) {
      texto = texto.replace(/[&]/g, "E");
      texto = texto.replace(/[']/g, " ");
      texto = texto.replace(/\s\s+/g, " ");
      texto = texto.replace(/[°]/g, "o");
      texto = texto.replace(/[º]/g, "o");
      texto = texto.replace(/[ª]/g, "a");
      texto = texto.replace(/[ ]/g, " ");
      texto = texto.replace(/[Ɵ]/g, "");
      texto = texto.normalize("NFD").replace(/([\u0300-\u036f]|[^0-9a-zA-Z/,.-\s])/g, ""); //A-Z/,.- aceita barra, vírgula, ponto, traço
      texto = texto.replace(/[\r\n]/g, " ");
      texto = texto.replace(/[\n]/g, " ");
      texto = texto.trim();
    }
    return texto;
  },
  removeEspeciaisMais(texto) {
    if (texto) {
      texto = texto.replace(/[&]/g, "E");
      texto = texto.replace(/[']/g, " ");
      texto = texto.replace(/\s\s+/g, " ");
      texto = texto.replace(/[°]/g, "o");
      texto = texto.replace(/[º]/g, "o");
      texto = texto.replace(/[ª]/g, "a");
      texto = texto.replace(/[ ]/g, " ");
      texto = texto.replace(/[Ɵ]/g, "");
      texto = texto.normalize("NFD").replace(/([\u0300-\u036f]|[^0-9a-zA-Z/,.+-\s])/g, ""); //A-Z/,.- aceita barra, vírgula, ponto, traço, +
      texto = texto.replace(/[\r\n]/g, " ");
      texto = texto.replace(/[\n]/g, " ");
      texto = texto.trim();
    }
    return texto;
  },
  removeEspeciaisAll(texto) {
    if (texto) {
      texto = texto.replace(/[&]/g, "E");
      texto = texto.replace(/[']/g, " ");
      texto = texto.replace(/\s\s+/g, " ");
      texto = texto.replace(/[°]/g, "o");
      texto = texto.replace(/[º]/g, "o");
      texto = texto.replace(/[ª]/g, "a");
      texto = texto.replace(/[ ]/g, " ");
      texto = texto.replace(/[Ɵ]/g, "");
      texto = texto.normalize("NFD").replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, "");
      texto = texto.replace(/[\r\n]/g, " ");
      texto = texto.replace(/[\n]/g, " ");
      texto = texto.trim();
    }
    return texto;
  },
  somenteNumeros(valor) {
    return valor.replace(/[^0-9]/g, "");
  },
  filtrarObjetos(item, queryText, itemText) {
    if (queryText === null || queryText.length === 0) {
      return true;
    }
    var text = util.removeAcentos(item["nome"]).toLowerCase();
    queryText = util.removeAcentos(queryText).toLowerCase();
    return itemText && itemText.length > 0 && text.indexOf(queryText) > -1;
  },
  filtrarItens(item, queryText, itemText) {
    if (queryText === null || queryText.length === 0) {
      return true;
    }
    var text = util.removeAcentos(item).toLowerCase();
    queryText = util.removeAcentos(queryText).toLowerCase();
    return itemText && itemText.length > 0 && text.indexOf(queryText) > -1;
  },
  filtrarUFs(item, queryText, itemText) {
    if (queryText === null || queryText.length === 0) {
      return true;
    }
    var text = (queryText.length > 2 ? util.removeAcentos(item["nome"]).toLowerCase() : "") + "-" + item["sigla"].toLowerCase() + "-" + item["pais"].toLowerCase();
    queryText = util.removeAcentos(queryText).toLowerCase();
    return itemText && itemText.length > 0 && text.indexOf(queryText) > -1;
  },
  filtrarObjetosIdentificacao(item, queryText, itemText) {
    if (queryText === null || queryText.length === 0) {
      return true;
    }
    var text = "";
    if (queryText == util.somenteNumeros(queryText)) {
      text = item["identificacao"];
    } else {
      text = util.removeAcentos(item["nome"]).toLowerCase();
    }
    queryText = util.removeAcentos(queryText).toLowerCase();
    return itemText && itemText.length > 0 && text.indexOf(queryText) > -1;
  },
  formatIdentificacao(identificacao) {
    if (!identificacao) {
      return "";
    }

    const identificacaoSemMascara = identificacao.toString().trim().toUpperCase().replace(/[./-]/g, "");

    if (/^\d{11}$/.test(identificacaoSemMascara)) {
      //* CPF
      return (
        identificacaoSemMascara.substring(0, 3) +
        "." +
        identificacaoSemMascara.substring(3, 6) +
        "." +
        identificacaoSemMascara.substring(6, 9) +
        "-" +
        identificacaoSemMascara.substring(9)
      );
    }

    if (/^\d{14}$/.test(identificacaoSemMascara)) {
      //* CNPJ numérico legado
      return (
        identificacaoSemMascara.substring(0, 2) +
        "." +
        identificacaoSemMascara.substring(2, 5) +
        "." +
        identificacaoSemMascara.substring(5, 8) +
        "/" +
        identificacaoSemMascara.substring(8, 12) +
        "-" +
        identificacaoSemMascara.substring(12)
      );
    }

    if (/^([A-Z\d]){12}(\d){2}$/.test(identificacaoSemMascara)) {
      //* CNPJ alfanumérico
      return identificacaoSemMascara;
    }

    return identificacao;
  },

  abreviaNome(nome) {
    if (!nome || !nome.trim() || !nome.includes(" ")) {
      return nome;
    }
    var retorno = nome.trim;
    retorno = nome.split(" ")[0];
    var itens = nome.split(" ");
    for (let index = 0; index < itens.length; index++) {
      if (index) {
        const item = itens[index];
        if (item.startsWith("(") && item.endsWith(")")) {
          retorno += item;
        } else {
          retorno += " " + item.substring(0, 1);
        }
      }
    }
    return retorno;
  },

  abreviaEmail(email) {
    var retorno = "***";
    if (email.includes("@")) {
      const partes = email.split("@");
      const pontos = partes[1].split(".");
      retorno = partes[0].substring(0, 2) + "***@" + partes[1].substring(0, 2) + "***." + pontos[pontos.length - 1];
    }
    return retorno;
  },

  getModuloTela(path, idUsuario) {
    var modulo = "";
    var tela = "";

    if (path == "/") {
      modulo = "Administrativo";
      tela = "SuitaSIM";
    }
    if (path.startsWith("/administrativo/")) {
      modulo = "Administrativo";
    } else if (path.startsWith("/assinaturas/")) {
      modulo = "Assinaturas";
    } else if (path.startsWith("/comercial/")) {
      modulo = "Comercial";
    } else if (path.startsWith("/financeiro/")) {
      modulo = "Financeiro";
    } else if (path.startsWith("/flip/")) {
      modulo = "Flip";
    } else if (path.startsWith("/editorial/")) {
      modulo = "Editorial";
    }

    //* Telas do Módulo Administrativo
    if (path == "/administrativo/desktop") {
      tela = "Administrativo"; //OK
    } else if (path == "/administrativo/usuario/" + idUsuario) {
      tela = "Seu_Usuario"; //OK
    } else if (path.includes("/administrativo/usuario")) {
      tela = "Usuario"; //OK
    } else if (path.includes("/administrativo/rede")) {
      tela = "Rede"; //OK
    } else if (path.includes("/administrativo/grupo")) {
      tela = "Grupo"; //OK
    } else if (path.includes("/administrativo/pais")) {
      tela = "Pais"; //OK
    } else if (path.includes("/administrativo/uf")) {
      tela = "Estado"; //OK
    } else if (path.includes("/administrativo/municipio")) {
      tela = "Municipio"; //OK
    } else if (path.includes("/administrativo/site")) {
      tela = "Site"; //OK
    } else if (path.includes("/administrativo/perfi")) {
      tela = "Perfil"; //OK
    } else if (path.includes("/administrativo/tipo")) {
      tela = "Tipo_Logradouro"; //OK
    } else if (path.includes("/administrativo/cep")) {
      tela = "Logradouro"; //OK
    } else if (path.includes("/administrativo/agente")) {
      tela = "Cliente"; //OK
    } else if (path.includes("/administrativo/configs-emails") || path.includes("/administrativo/config-email")) {
      tela = "Configuracao_Email"; //OK
    } else if (path.includes("/administrativo/feriado")) {
      tela = "Feriado"; //OK
    } else if (path.includes("/administrativo/formas-pagamento") || path.includes("/administrativo/forma-pagamento")) {
      tela = "Forma_Pagamento"; //OK
    } else if (path.includes("/administrativo/motivo")) {
      tela = "Motivo_Contato"; //OK
    } else if (path.includes("/administrativo/ramos-atividade") || path.includes("/administrativo/ramo-atividade")) {
      tela = "Ramo_Atividade"; //OK
    } else if (path.includes("/administrativo/radio")) {
      tela = "Programacao_Radio";
    } else if (path.includes("/administrativo/tv")) {
      tela = "Programacao_TV";
    } else if (path.includes("/administrativo/acervo-ceps")) {
      tela = "Acervo_Logradouros";
    } else if (path.includes("/administrativo/acervo-clientes")) {
      tela = "Acervo_Clientes";
    }

    //* Telas do Módulo Assinaturas
    if (path.includes("/assinaturas/assinante")) {
      modulo = "Administrativo";
      tela = "Cliente";
    } else if (path.includes("/assinaturas/assinatura") && path.split("/").length == 4) {
      tela = "Assinatura";
    } else if (path.includes("/assinaturas/assinatura")) {
      tela = "Captacao";

      //* Ações
    } else if (path.includes("/assinaturas/clube-assinante")) {
      modulo += "/Acoes";
      tela = "Clube_Assinante";
    } else if (path.includes("/assinaturas/cobranca")) {
      modulo = "Financeiro";
      tela = "Cobranca";
    } else if (path.includes("/assinaturas/contatos")) {
      modulo = "Administrativo";
      tela = "Contatos";
    } else if (path.includes("/assinaturas/cupons-promocoes")) {
      modulo += "/Acoes";
      tela = "Cupons";
    } else if (path.includes("/assinaturas/reclamacoes") && !path.includes("/assinaturas/reclamacoes-padrao")) {
      modulo += "/Acoes";
      tela = "Reclamacoes";
    } else if (path.includes("/assinaturas/recuperacao")) {
      modulo += "/Acoes";
      tela = "Recuperacao";

      //* Paywall
    } else if (path.includes("/assinaturas/paywall/plano")) {
      modulo += "/Paywall";
      tela = "Plano";
    } else if (path.includes("/assinaturas/paywall/assine")) {
      modulo += "/Paywall";
      tela = "Assine";

      //* Roteiro de Entrega
    } else if (path.includes("/assinaturas/entregador")) {
      modulo += "/Roteiro";
      tela = "Entregador";
    } else if (path.includes("/assinaturas/rota")) {
      modulo += "/Roteiro";
      tela = "Rota";
    } else if (path.includes("/assinaturas/tipos-logradouro") || path.includes("/assinaturas/tipo-logradouro")) {
      modulo = "Administrativo"; //pois é tela comum aos módulos
      tela = "Tipo_Logradouro";
    } else if (path.includes("/assinaturas/cep") || path.includes("/assinaturas/ceps")) {
      modulo = "Administrativo"; //pois é tela comum aos módulos
      tela = "Logradouro";
    } else if (path.includes("/assinaturas/roteiro-ordem")) {
      modulo += "/Roteiro";
      tela = "Ordem";
    } else if (path.includes("/assinaturas/roteiro-entrega")) {
      modulo += "/Roteiro";
      tela = "Roteiro";
    } else if (path.includes("/assinaturas/roteiro-historico")) {
      modulo += "/Roteiro";
      tela = "Histórico";

      //* Administração Planos
    } else if (path.includes("/assinaturas/modalidade")) {
      modulo += "/Planos";
      tela = "Modalidade";
    } else if (path.includes("/assinaturas/produto")) {
      modulo += "/Planos";
      tela = "Produto";
    } else if (path.includes("/assinaturas/promocoes") || path.includes("/assinaturas/promocao")) {
      modulo += "/Planos";
      tela = "Promocao";
    } else if (path.includes("/assinaturas/regras-ajuste") || path.includes("/assinaturas/regra-ajuste")) {
      modulo = "Administrativo";
      tela = "Regra_Ajuste";
    } else if (path.includes("/assinaturas/plano")) {
      modulo += "/Planos";
      tela = "Plano";

      //* Administração Diversos
    } else if (path.includes("/assinaturas/etapas-cobranca") || path.includes("/assinaturas/etapa-cobranca")) {
      modulo = "Financeiro";
      tela = "Etapa_Cobranca";
    } else if (path.includes("/assinaturas/modos-entrega") || path.includes("/assinaturas/modo-entrega")) {
      modulo += "/Diversos";
      tela = "Modo_entrega";
    } else if (path.includes("/assinaturas/motivos-cancelamento") || path.includes("/assinaturas/motivo-cancelamento")) {
      modulo += "/Diversos";
      tela = "Motivo_Cancelamento";
    } else if (path.includes("/assinaturas/reclamacoes-padrao") || path.includes("/assinaturas/reclamacao-padrao")) {
      modulo += "/Diversos";
      tela = "Motivo_Reclamacao";
    } else if (path.includes("/assinaturas/motivos-suspensao") || path.includes("/assinaturas/motivo-suspensao")) {
      modulo += "/Diversos";
      tela = "Motivo_Suspensao";
    } else if (path.includes("/assinaturas/orige")) {
      modulo += "/Diversos";
      tela = "Origem_Venda";
    } else if (path.includes("/assinaturas/setor")) {
      modulo += "/Diversos";
      tela = "Setor";

      //* Venda Avulsa
    } else if (path.includes("/assinaturas/tipos-banca") || path.includes("/assinaturas/tipo-banca")) {
      modulo += "/Venda_Avulsa";
      tela = "Tipo_Banca";
    } else if (path.includes("/assinaturas/banca")) {
      modulo = "Administrativo";
      tela = "Cliente";
    } else if (path.includes("/assinaturas/venda-avulsa-tabela")) {
      modulo += "/Venda_Avulsa";
      tela = "Tabela";
    } else if (path.includes("/assinaturas/venda-avulsa-reparte")) {
      modulo += "/Venda_Avulsa";
      tela = "Reparte";
    } else if (path.includes("/assinaturas/venda-avulsa-roteiro-entrega")) {
      modulo += "/Roteiro";
      tela = "Roteiro";
    } else if (path.includes("/assinaturas/venda-avulsa-faturamento")) {
      modulo += "/Venda_Avulsa";
      tela = "Faturamento";

      //* Configurações
    } else if (path.includes("/assinaturas/config-fechamento-roteiro")) {
      modulo += "/Config";
      tela = "Fechamento_Roteiro";

      //* Regras Comissionamento
    } else if (path.includes("/assinaturas/regras-comissionamento") || path.includes("/assinaturas/regra-comissionamento")) {
      modulo += "/Comissionamento";
      tela = "Regras";

      //* Relatórios
    } else if (path.includes("/assinaturas/relatorios/carteira")) {
      modulo += "/Relatorios";
      tela = "Carteira";
    }

    //* Telas do Módulo Comercial
    if (path.includes("/comercial/anunciante")) {
      modulo = "Administrativo";
      tela = "Cliente";
    } else if (path.includes("/comercial/pacote")) {
      tela = "Pacote";
    } else if (path.includes("/comercial/anuncio") && !path.includes("/comercial/anuncio-tabela")) {
      tela = "Anuncio";

      //* Ações
    } else if (path.includes("/comercial/cobranca")) {
      modulo = "Financeiro";
      tela = "Cobranca";
    } else if (path.includes("/comercial/contatos")) {
      modulo = "Administrativo";
      tela = "Contatos";

      //* Administração
    } else if (path.includes("/comercial/produto")) {
      modulo += "/Administracao";
      tela = "Produto";
    } else if (path.includes("/comercial/caderno")) {
      modulo += "/Administracao";
      tela = "Caderno";
    } else if (path.includes("/comercial/regras-ajuste") || path.includes("/comercial/regra-ajuste")) {
      modulo = "Administrativo"; //pois é tela comum aos módulos
      tela = "Regra_Ajuste";
    } else if (path.includes("/comercial/formato")) {
      modulo += "/Administracao";
      tela = "Formato";
    } else if (path.includes("/comercial/determinac")) {
      modulo += "/Administracao";
      tela = "Determinacao";
    } else if (path.includes("/comercial/colocac")) {
      modulo += "/Administracao";
      tela = "Colocacao";
    } else if (path.includes("/comercial/sec")) {
      modulo += "/Administracao";
      tela = "Secao";
    } else if (path.includes("/comercial/anuncio-tabela")) {
      modulo += "/Administracao";
      tela = "Tabela";
    } else if (path.includes("/comercial/texto")) {
      modulo += "/Administracao";
      tela = "Texto";

      //* Administração Diversos
    } else if (path.includes("/comercial/etapas-cobranca") || path.includes("/comercial/etapa-cobranca")) {
      modulo = "Financeiro";
      tela = "Etapa_Cobranca";
    }

    //* Telas do Módulo Financeiro
    if (path.includes("/financeiro/cliente")) {
      modulo = "Administrativo";
      tela = "Cliente";

      //* Contas a Receber
    } else if (path.includes("/financeiro/operacoes/receber") || path.includes("/financeiro/operacao/receber")) {
      modulo += "/Receber";
      tela = "Operacao";
    } else if (path.includes("/financeiro/parcelas/receber")) {
      modulo += "/Receber";
      tela = "Parcelas";
    } else if (path.includes("/financeiro/remessas/receber")) {
      modulo += "/Receber";
      tela = "Remessas";
    } else if (path.includes("/financeiro/retornos/receber")) {
      modulo += "/Receber";
      tela = "Retornos";

      //* Contas a Pagar
    } else if (path.includes("/financeiro/operacoes/pagar") || path.includes("/financeiro/operacao/pagar")) {
      modulo += "/Pagar";
      tela = "Operacao";
    } else if (path.includes("/financeiro/parcelas/pagar")) {
      modulo += "/Pagar";
      tela = "Parcelas";
    } else if (path.includes("/financeiro/remessas/pagar")) {
      modulo += "/Pagar";
      tela = "Remessas";
    } else if (path.includes("/financeiro/retornos/pagar")) {
      modulo += "/Pagar";
      tela = "Retornos";

      //* Diversos
    } else if (path.includes("/financeiro/transferencia")) {
      modulo += "/Diversos";
      tela = "Transferencia";
    } else if (path.includes("/financeiro/cobranca")) {
      tela = "Cobranca";
    } else if (path.includes("/financeiro/contatos")) {
      modulo = "Administrativo";
      tela = "Contatos";
    } else if (path.includes("/financeiro/emails")) {
      modulo += "/Diversos";
      tela = "Emails";
    } else if (path.includes("/financeiro/extrato")) {
      modulo += "/Diversos";
      tela = "Extrato";
    } else if (path.includes("/financeiro/fluxo-caixa")) {
      modulo += "/Diversos";
      tela = "Fluxo_Caixa";

      //* Administração
    } else if (path.includes("/financeiro/banco")) {
      modulo += "/Administracao";
      tela = "Banco";
    } else if (path.includes("/financeiro/cedente")) {
      modulo += "/Administracao";
      tela = "Cedente";
    } else if (path.includes("/financeiro/centros-custo") || path.includes("/financeiro/centro-custo")) {
      modulo += "/Administracao";
      tela = "Centro_Custo";
    } else if (path.includes("/financeiro/etapas-cobranca") || path.includes("/financeiro/etapa-cobranca")) {
      tela = "Etapa_Cobranca";
    } else if (path.includes("/financeiro/fornecedor")) {
      modulo = "Administrativo";
      tela = "Cliente";
    } else if (path.includes("/financeiro/motivos-parcela") || path.includes("/financeiro/motivo-parcela")) {
      modulo += "/Administracao";
      tela = "Motivo_parcela";

      //* Plano de Contas
    } else if (path.includes("/financeiro/conta")) {
      modulo += "/Plano_Contas";
      tela = "Conta";

      //* Notas Fiscais
    } else if (path.includes("/financeiro/nfe")) {
      modulo += "/Notas_Fiscais";
      tela = "NFe";
    } else if (path.includes("/financeiro/nfsc")) {
      modulo += "/Notas_Fiscais";
      tela = "NFSC";
    } else if (path.includes("/financeiro/nfse")) {
      modulo += "/Notas_Fiscais";
      tela = "NFSe";
    } else if (path.includes("/financeiro/nfcom")) {
      modulo += "/Notas_Fiscais";
      tela = "NFCom";
    } else if (path.includes("/financeiro/fechamento/nfsc")) {
      modulo += "/Notas_Fiscais";
      tela = "Fechamento_NFSC";
    } else if (path.includes("/financeiro/fechamento/sped")) {
      modulo += "/Notas_Fiscais";
      tela = "Fechamento_SPED";

      //* Relatórios
    } else if (path.includes("/financeiro/relatorios/apresentacao")) {
      modulo += "/Relatorios";
      tela = "Apresentacao";
    } else if (path.includes("/financeiro/relatorios/balancete")) {
      modulo += "/Relatorios";
      tela = "Balancete";
    } else if (path.includes("/financeiro/relatorios/cliente-fornecedor")) {
      modulo += "/Relatorios";
      tela = "Cliente_Fornecedor";
    } else if (path.includes("/financeiro/relatorios/balancete")) {
      modulo += "/Relatorios";
      tela = "Perfil";
    } else if (path.includes("/financeiro/relatorios/conciliacao")) {
      modulo += "/Relatorios";
      tela = "Conciliacao";

      //* Configurações
    } else if (path.includes("/financeiro/config-nfe")) {
      modulo += "/Config";
      tela = "NFe";
    } else if (path.includes("/financeiro/config-nfsc")) {
      modulo += "/Config";
      tela = "NFSC";
    } else if (path.includes("/financeiro/config-nfse")) {
      modulo += "/Config";
      tela = "NFSe";
    } else if (path.includes("/financeiro/config-nfcom")) {
      modulo += "/Config";
      tela = "NFCom";
    }

    //* Telas do Módulo Flip
    if (path.includes("/flip/edicoes")) {
      tela = "Edicoes";
    }

    //* Telas do Módulo Editorial
    if (path.includes("/administrativo/editoria")) {
      modulo = "Editorial";
      tela = "Editoria";
    } else if (path.includes("/editorial/artigo")) {
      tela = "Artigo";
    }

    return modulo ? [modulo, tela] : null;
  }
};

export default util;
